import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JobPlateTestService } from 'src/app/services/job-plate-test.service';
import { ForceCalculatorService } from 'src/app/services/force-calculator.service';
import { ReactionLoadService } from 'src/app/services/reaction-load.service';
import { MaterialService } from 'src/app/services/material.service';
import * as moment from 'moment';
import { UUID } from 'angular2-uuid';
import { platebearingtest } from '../../../../../models/platebearingtest';
import { JobPlateTestLoad } from '../../../../../models/jobPlateTestLoad';
import { SnotifyService } from 'ng-snotify';
import { JobService } from '../../../../../services/job.service';

@Component({
  selector: 'app-plate-bearing-manage-review',
  templateUrl: './plate-bearing-review.component.html',
  styleUrls: ['./plate-bearing-review.component.scss']
})
export class PlateBearingManageReviewComponent implements OnInit {
  id: string;
  jobId: string;
  test: platebearingtest;
  created_Date:string;
  ButtonMsg: string = "Recalculate";
  reactionLoads = [];
  showReactionLoadOther = false;
  plateTestTypeId: string;
  otherReactionLoad: string;
  fromPage: string = "";
  materials = [];
  plateTestTypes = [];
  editing: boolean = false;
  loading: boolean = false;
  reason_For_ReIssue: string = "";
  remarks: string = "";
  locationReference: string = "";
  customerReference: string = "";
  constructor(private route: ActivatedRoute, private jobPlateTestService: JobPlateTestService, private snotifyService: SnotifyService,
    private forceCalculatorService: ForceCalculatorService, private router: Router, private jobService: JobService,
    private reactionLoadService: ReactionLoadService, private materialService: MaterialService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(async (paramsMap) => {
      var id = paramsMap.get("id");
      var jobId = paramsMap.get("jobId");
      if (id == "create")
        id = null;

      if (jobId != null) {
        this.jobId = jobId;
      }

      if (jobId != null && id == null)
        this.fromPage = "/scheduler";
      else if (jobId == null && id != null)
        this.fromPage = "/reports/concretepour";
      else
        this.fromPage = "/reviews/manage";

      this.reactionLoads = await this.reactionLoadService.get();
      this.materials = await this.materialService.get();
      this.plateTestTypes = await this.jobPlateTestService.getTypes();
      //console.log(this.plateTestTypes);

      if (id != null) {
        this.id = id;
        this.editing = true;
        this.jobPlateTestService.get(this.id).then((test) => {
          test.jobPlateTestLoads = test.jobPlateTestLoads.sort((a, b) => (a.position - b.position));
          //console.log(test);
          var idx = this.reactionLoads.findIndex(p => p.load == test.typeOfReactionLoad);
          if (idx == -1) {
            this.otherReactionLoad = test.typeOfReactionLoad;
            this.showReactionLoadOther = true;
            test.typeOfReactionLoad = "Other";
          }
          this.plateTestTypeId = test.plateTestTypeId;
          this.test = test;
          this.formatForDisplay(this.test);
          this.created_Date = this.test.createdAt;
          console.log(test);
          this.plateTestTypeId = test.plateTestTypeId;
          this.locationReference = test.locationReference;
          this.remarks = test.remarks;
          this.customerReference = test.customerReference;

        });
      } else {
        this.test = new platebearingtest();
        this.test.id = UUID.UUID();
        this.test.createdAt = moment().toDate();
        this.ButtonMsg = "Calculate";
        if (jobId != null) {
          this.test.jobId = jobId;
          this.jobService.get(jobId).then((data) => {
            if (data != undefined && data.project != undefined)
              this.customerReference = data.project.projectName;
          });
        }
      }
    });
  }
  resetTest() {
    this.test.id = UUID.UUID();
    this.plateTestTypeChanged();
    this.test.force = undefined;
    this.test.cbr = undefined;
    this.test.k = undefined;

  }
  back() {
    if (this.fromPage != "/reviews/manage")
      this.router.navigate([this.fromPage], {});
    else
      this.router.navigate(['reviews/manage'], { queryParams: { id: this.jobId, jobType: 1 } });
  }

  formatForDisplay(test) {
    for (let load of test.jobPlateTestLoads) {
      var c = load.avg;
      if (!this.getNumberOfDecimalPlaces(load.load1)) {
        load.load1 = this.roundToTwo((Math.round(load.load1 * 100) / 100)); //.toFixed(2);
        // load.load1 = load.load1.toFixed(2);
      } if (!this.getNumberOfDecimalPlaces(load.load2)) {
        load.load2 = this.roundToTwo((Math.round(load.load2 * 100) / 100)); //.toFixed(2);
        // load.load2 = load.load2.toFixed(2);
      } if (!this.getNumberOfDecimalPlaces(load.load3)) {
        load.load3 = this.roundToTwo((Math.round(load.load3 * 100) / 100)); //.toFixed(2))
        //  load.load3 = load.load3.toFixed(2);
      } if (!this.getNumberOfDecimalPlaces(load.avg)) {
        load.avg = this.roundToTwo((Math.round(load.avg * 100) / 100)); //.toFixed(2);
        // load.avg = load.avg.toFixed(2);
      }
      if (c != load.avg) {
        //console.log("formatForCalculation");
        //console.log(c);
        //console.log(load.avg);
        
      }
    }
  }

  formatForCalculation(test) {
    for (let load of test.jobPlateTestLoads) {
      var c = load.avg;
      
      load.load1 = Math.round(load.load1 * 100) / 100;
      load.load2 = Math.round(load.load2 * 100) / 100;
      load.load3 = Math.round(load.load3 * 100) / 100;
      load.avg = Math.round(load.avg * 100) / 100;
      if (c != load.avg) {
        //console.log("formatForCalculation");
        //console.log(c);
        //console.log(load.avg);
      }

    }
  }
  
  recalculate(toSave:boolean = false, back:boolean = false) {
    this.formatForCalculation(this.test);

      var idx = 0;
      for (var i = 0; i < this.plateTestTypes.length; i++) {
        var plt = this.plateTestTypes[i];
        if (plt.id == this.plateTestTypeId)
          idx = i;
    }

      var newplt = this.plateTestTypes[idx];

      this.loading = true;
      var calcDTO = {
        plateTestTypeId: this.plateTestTypeId,
        plateLoadSize: newplt.plateLoadSize.load,
        loadIncrement: newplt.loadIncrement,
        loads: this.test.jobPlateTestLoads,
      }
     
    //console.log(calcDTO);
    this.jobPlateTestService.calculateCBR(calcDTO).then((data) => {

      //console.log(data);
      this.test.cbr = data.cbr;
      this.test.force = data.force;
      this.test.k = data.k;

      if (toSave) {
        if (!this.validate()) {
          this.loading = false;
          return;
        }
        

        if (this.otherReactionLoad != null && this.otherReactionLoad != "") {
          this.test.typeOfReactionLoad = this.otherReactionLoad;
        }
        this.test.plateTestTypeId = this.plateTestTypeId;

        for (var a = 0; a < this.test.jobPlateTestLoads.length; a++) {
          var t = this.test.jobPlateTestLoads[a];
          if (t.avg == null || Number.isNaN(t.avg))
            t.avg = 0;
        }

        this.test.reason_For_ReIssue = this.reason_For_ReIssue;
        this.test.remarks = this.remarks           ;
        this.test.locationReference = this.locationReference ;
        this.test.customerReference = this.customerReference ;

        //console.log(this.test);


        this.jobPlateTestService.update(this.test).then(data => {
          this.loading = false;
          this.snotifyService.success("successfully saved test");
          if (back)
            this.back();
          else
            this.resetTest();
        }, error => {
          this.snotifyService.error("Error csaving report");
          //console.log(error);
          this.loading = false;
        });
      } else {
        this.loading = false;
      }

     
    }, error => {
      this.snotifyService.error("Error calculating");
      //console.log(error);
      this.loading = false;
    });
  }

  update(back:boolean) {
    this.recalculate(true, back);  
  }

  validate() {
    let isValid: boolean = true;

    for (let load of this.test.jobPlateTestLoads) {
      if (load.load1 == undefined || load.load1 == 'undefined' || load.load1 == null) {
        isValid = false;
        this.snotifyService.error("Please ensure all values are filled");
        break;
      }
      if (load.load2 == undefined || load.load2 == 'undefined' || load.load2 == null) {
        isValid = false;
        this.snotifyService.error("Please ensure all values are filled");
        break;
      }
      
      if (load.load3 == undefined || load.load3 == 'undefined' || load.load3 == null) {
        isValid = false;
        this.snotifyService.error("Please ensure all values are filled");
        break;
      } 
    }
    if (this.editing && !this.checkString(this.reason_For_ReIssue)) {
      isValid = false;
      this.snotifyService.error("Please enter the reason for re-issue");
    }

    if (!this.checkString(this.locationReference)) {
      
      isValid = false;
      this.snotifyService.error("Please enter the location reference");
    }

    if (!this.checkString(this.test.typeOfReactionLoad)) {
      isValid = false;
      this.snotifyService.error("Please enter the type of reaction load");
    }

    if (this.test.materialId == undefined || this.test.materialId < 0 || this.test.materialId == null) {
      isValid = false;
      this.snotifyService.error("Please enter the Material");
    }
    console.log("isValid");
    console.log(isValid);
    console.log("this.locationReference" + this.locationReference);
    console.log("this.typeOfReactionLoad" + this.test.typeOfReactionLoad);
    console.log("this.typeOfReactionLoad" + this.test.materialId);
    console.log("this.editing" + this.editing);
    console.log("this.reason_For_ReIssue" + this.reason_For_ReIssue);
    return isValid;
  }
  checkString(str) {
    console.log("testing str: " + str);
    if (str == undefined || str == 'undefined' || str == null || str == '')
      return false;
    else
      return true;
  }
  getNumberOfDecimalPlaces(value: string) {
    let parts: string[] = value.toString().split(".", 2);
    return (parts.length == 2 && parts[1].length == 2);
  }

  plateTestTypeChanged() {
    var idx = 0;
    for (var i = 0; i < this.plateTestTypes.length; i++) {
      var plt = this.plateTestTypes[i];
      if (plt.id == this.plateTestTypeId)
        idx = i;
    }
    var newplt = this.plateTestTypes[idx];
    //console.log(newplt);
    this.test.jobPlateTestLoads = newplt.plateLoads.sort((a, b) => (a.position - b.position));
    
    for (var i = 0; i < this.test.jobPlateTestLoads.length; i++) {
      let plt: JobPlateTestLoad = this.test.jobPlateTestLoads[i];
      plt.id = UUID.UUID();
      plt.load1 = "0.00";
      plt.load2 = "0.00";
      plt.load3 = "0.00";
      plt.avg = 0.00;
    }
  }

  loadChanged(load) {
    var avg:number = 0;
    var enteredAmount = 1;
    if (load.load1 != undefined && load.load1 != "" && +load.load1 > 0) {
      avg += +load.load1;
      enteredAmount = 1;
    }
    if (load.load2 != undefined && load.load2 != "" && +load.load2 > 0) {
      avg += +load.load2;
      enteredAmount = 2;
    }

    if (load.load3 != undefined && load.load3 != "" && +load.load3 > 0) {
      avg += +load.load3;
      enteredAmount = 3;
    }


    load.avg = ((Math.round((avg / enteredAmount) * 100) / 100).toFixed(2));

  }
 
    
  reactionLoadChanged() {
    this.otherReactionLoad = "";
    this.showReactionLoadOther = this.test.typeOfReactionLoad == "Other";
  }
  private roundToTwo(val: any ){
    let log: boolean;
    if(val == 1.65 || val == 1.66) log = true;
      else log = false;
      if(log){
        //console.log("roundToTwo");
        //console.log(val);
      }

    if(isNaN(val))
      return "0.00";
    let prefix = parseInt(val);
    var cal = val - prefix;
    if (log) {
      //console.log(prefix);
      //console.log(cal);
    }
    if (cal == 0.55){
      //console.log(".55");
      val = val + 0.05;
    }
    if (log) {
      //console.log(val.toFixed(2));
    }
    return val.toFixed(2);
  }
}
